var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class HttpClientImpl {
    constructor(adapter, config) {
        this.adapter = adapter;
        this.config = config;
    }
    delete(path) {
        return this.processPath('DELETE', path);
    }
    get(path) {
        return this.processPath('GET', path);
    }
    head(path) {
        return this.processPath('HEAD', path);
    }
    options(path) {
        return this.processPath('OPTIONS', path);
    }
    post(path) {
        return this.processPath('POST', path);
    }
    put(path) {
        return this.processPath('PUT', path);
    }
    patch(path) {
        return this.processPath('PATCH', path);
    }
    processPath(method, path) {
        if (path) {
            return this.path(path).process(method);
        }
        else {
            return this.process(method);
        }
    }
    process(method) {
        let currentReq = this;
        for (const middleware of this.config.middlewares) {
            currentReq = middleware.handleRequest(currentReq);
        }
        return this.adapter.send(currentReq.config, method);
    }
    body(body) {
        const newReq = Object.create(this);
        newReq.config = Object.create(newReq.config);
        newReq.config.body = body;
        return newReq;
    }
    header(name, value) {
        const newReq = Object.create(this);
        newReq.config = Object.create(newReq.config);
        newReq.config.headers = Object.assign({}, newReq.config.headers);
        newReq.config.headers[name] = value;
        return newReq;
    }
    path(path) {
        const newReq = Object.create(this);
        newReq.config = Object.create(newReq.config);
        newReq.config.paths = [...newReq.config.paths, path];
        return newReq;
    }
    use(middleware) {
        const newReq = Object.create(this);
        newReq.config = Object.create(newReq.config);
        newReq.config.middlewares = [...newReq.config.middlewares, middleware];
        return newReq;
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    query(name, value) {
        const newReq = Object.create(this);
        newReq.config = Object.create(newReq.config);
        newReq.config.query = Object.assign({}, newReq.config.query);
        newReq.config.query[name] = value;
        return newReq;
    }
}
